module.exports = __webpack_public_path__ + "static/ff-saleslanding-image-body-foodie-forfeathering-thanh-soledas-Kf1nBG76Xe8-unsplash-wide.a79cc024.jpg";